<template>
  <div class="wrapper hefei-bg-f5">
    <div class="consult-tip" ref="tip">
      <span>请{{ timeStr }}内完成支付，超时订单自动取消</span>
      <i @click="closeTip"></i>
    </div>
    <div class="container-wrap-form">
      <div class="form-bg recharge-detail">
        <div class="detail-table form-table">
          <div class="table-left">
            <h2 class="form-font-dark">{{ order.consultType | consultTypeFilter }}</h2>
          </div>
          <div class="table-right">
            <span class="form-font-dark">{{ order.money || "-" }}元</span>
          </div>
        </div>
        <!-- <div class="detail-table form-table account-table">
          <div class="table-left">
            <h2 class="form-font-dark">优惠金额</h2>
          </div>
          <div class="table-right">
            <span class="form-font-grey">19元</span>
          </div>
        </div>-->
        <div class="detail-table form-table selfpay-table">
          <div class="table-left">
            <h2 class="form-font-dark">总待支付费用</h2>
          </div>
          <div class="table-right selfpay-right">
            <span class="blue">
              <span class="blue-plus">{{ order.money || "-" }}元</span>
            </span>
          </div>
        </div>
      </div>

      <div class="form-bg recharge-pay-type">
        <div class="pay-type-item">
          <label
            class="clearfix"
            @click="selectPayChannel(channel)"
            v-for="channel in payChannels"
            :key="channel.channelId"
          >
            <div class="pay-type-logo fn-fl">
              <img :src="channel.imageUrl" alt>
            </div>
            <div class="pay-type-name fn-fl">{{ channel.name }}</div>
            <i :class="{ checked: activeChannel === channel.channelId }"></i>
          </label>
        </div>
      </div>
      <div class="grid-m fix-footer-fill"></div>
    </div>
    <div class="recharge-fixed-btn">
      <a @click="getConsultStatus">确认支付</a>
    </div>
  </div>
</template>
<script>
import * as $services from "@/services/index";
export default {
  filters: {
    consultTypeFilter(value) {
      const consultTypeMap = {
        "01":"在线咨询-图文咨询",
        "02":"在线咨询-视频咨询",
        "03":"在线复诊-图文咨询",
        "04":"在线复诊-视频咨询",
      };
      return consultTypeMap[value] || "-";
    }
  },
  data() {
    return {
      activeChannel: "WX_PUB",
      timeStr: "",
      cutTime: 0,
      timer: "",
      params: {
        channel: "WX_PUB",
        orderNo: "",
        type: ""
      },
      order: {
        orderNo: "",
        doctorId: "",
        money: "",
        consultType: ""
      },
      status: "",
      payChannels: [
        // {
        //   channelId: 'ALI_WAP',
        //   name: '支付宝支付',
        //   imageUrl: require('../../assets/images/jidayi-hospital/icon-alipay.png')
        // },
        {
          channelId: "WX_PUB",
          name: "微信支付",
          imageUrl: require("../../assets/images/jidayi-hospital/icon-wechat.png")
        }
        // {
        //   channelId: 'UP_WAP',
        //   name: '云闪付',
        //   imageUrl: require('../../assets/images/jidayi-hospital/icon-unionPay.png'),
        // }
      ],
      credential: {}
    };
  },
  created() {
    this.handleOrder();
    this.getConsultInfo();
  },
  destroyed() {
    window.clearInterval(this.timer);
  },
  computed: {},
  methods: {
    handleOrder() {
      let { money, consultType, orderNo, type } = this.$route.query;
      this.order.orderNo = orderNo;
      this.order.money = money;
      this.order.consultType = consultType;
      // 2继续咨询下单，1咨询下单
      this.order.type = type;
      // console.log(this.$route.query)
    },
    countDown() {
      this.timer = setInterval(() => {
        if (this.cutTime <= 0) {
          this.cutTime = 0;
          clearInterval(this.timer);
          this.handleTimeout();
        } else {
          this.cutTime--;
          this.timeFormat();
        }
      }, 1000);
    },
    timeFormat() {
      var hh = parseInt(this.cutTime / 3600);
      var mm = parseInt(this.cutTime / 60) % 60;
      var ss = this.cutTime % 60;
      this.timeStr =
        (hh > 0 ? hh + "时" : "") +
        (hh > 0 || mm > 0 ? mm + "分" : "") +
        ss +
        "秒";
    },
    handleCountDown() {
      const type = this.order.type;
      if (type == "1") {
        this.getConsultInfo();
      } else {
        this.cutTime = 900;
        this.countDown();
      }
    },
    getConsultInfo() {
      $services
        .getConsultInfoByOrderNo({
          orderNo: this.order.orderNo,
          userType: "01"
        })
        .then(res => {
          this.cutTime = res.time;
          this.status = res.record.status;
          this.countDown();
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 查询订单状态, 拉起支付
    getConsultStatus() {
      $services
        .getConsultInfoByOrderNo({
          orderNo: this.order.orderNo,
          userType: "01"
        })
        .then(res => {
          this.status = res.record.status;
          if (this.status === "00") {
            this.getCredential();
          } else {
            this.$toast("你已支付过该订单");
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    closeTip() {
      this.$refs["tip"].style.display = "none";
    },
    paySucc() {
      this.$router.push({
        path: "/paymentSucc"
      });
    },
    payFail() {
      this.$router.push({
        path: "/paymentFail"
      });
    },
    handleTimeout() {
      this.$messagebox({
        title: "温馨提示",
        message:
          "您的订单已生成，请在15分钟内完成支付，否则系统将自动取消此订单",
        showCancelButton: true,
        cancelButtonText: "确认离开",
        confirmButtonText: "重新下单"
      }).then(action => {
        if (action === "confirm") {
          this.continuePayOrder()
        } else {
          this.handleCancel()
        }
      });
    },
    handleCancel() {
      this.$router.push({
        path: "/recordList",
        query: {
          userType: "01"
        }
      });
    },
    continuePayOrder() {
      $services
        .againOrder({
          orderNo: this.order.orderNo
        })
        .then(res => {
          // 更新订单号
          if (res.status == '0') {
            this.order.orderNo = res.orderNo;
            // 更新下单类别
            this.order.type = '2'
            this.getConsultStatus();
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },

    selectPayChannel(channel) {
      this.activeChannel = channel.channelId;
      this.params.channel = channel.channelId;
    },
    // 咨询支付，获取支付凭证
    getCredential() {
      // 组装参数
      this.params.orderNo = this.order.orderNo;
      this.params.type = this.order.type;
      // 渠道为WX_PUB,ALI_FACE增加入参
      if (this.activeChannel === "WX_PUB") {
        this.params.openId = this.$store.getter.openId;
      } else if (this.activeChannel === "ALI_FACE") {
        this.params.ftoken = "";
      }
      this.$http
        .getCredential(this.params)
        .then(res => {
          if (res) {
            this.handlePay(res);
          }
          console.log(res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    onBridgeReady(obj, callback) {
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: obj.appId, // 公众号名称，由商户传入
          timeStamp: obj.timeStamp, // 时间戳，自1970年以来的秒数
          nonceStr: obj.nonceStr, // 随机串
          package: obj.package,
          signType: obj.signType, // 微信签名方式:
          paySign: obj.paySign
          // 微信签名
        },
        function(res) {
          // 使用以下方式判断前端返回,微信团队郑重提示:res.err_msg将在用户支付成功后返回
          if (res.err_msg === "get_brand_wcpay_request:ok") {
            callback();
          } else if (res.err_msg === "get_brand_wcpay_request:cancel") {
            this.$toast("支付取消");
          } else {
            this.$toast("支付失败");
          }
        }
      );
    },
    wxPubPay(pub_pay, callback) {
      const obj = pub_pay;
      if (typeof WeixinJSBridge === "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            (obj, callback) => {
              this.onBridgeReady(obj, callback);
            },
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", (obj, callback) => {
            this.onBridgeReady(obj, callback);
          });
          document.attachEvent("onWeixinJSBridgeReady", (obj, callback) => {
            this.onBridgeReady(obj, callback);
          });
        }
      } else {
        this.onBridgeReady(obj, callback);
      }
    },
    handlePay(data) {
      const _channel = data.channel;
      switch (_channel) {
        case "ALI_WAP":
          // var redUrl = data.directUrl;
          // redUrl = redUrl.replace("http://188.16.1.36:20885/gateway.do", "https://openapi.alipay.com/gateway.do");
          // window.location.href = redUrl;
          break;
        case "WX_WAP":
          // window.location.href = data.directUrl;
          break;
        case "WX_PUB":
          if (
            typeof WeixinJSBridge !== "undefined" &&
            typeof data.credential.WX_PUB !== "undefined"
          ) {
            this.wxPubPay(data.credential.WX_PUB, () => {
              // 支持成功，跳转
              this.$toast("支付成功");
              //跳转IM聊天界面
              this.$router.push({
                path: "/imChat",
                query: { userType: "01", orderNo: this.params.orderNo }
              });
            });
          }
          break;
        case "UP_WAP":
          // 创建Form
          // var form = $(data.html);
          // 提交表单
          // form.submit();
          // $(data.html).appendTo($('body'));
          // $("#pay_form").submit();
          break;
        default:
          // 默认处理方法
          if (data.directUrl !== undefined && data.directUrl !== "") {
            window.location.href = data.directUrl;
          } else if (data.html !== "") {
            // 创建Form
            // var form = $(data.html);
            // 提交表单
            // form.submit();
          } else {
            this.$toast("返回未知错误");
          }
          break;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/patientEnd/payment.vue